// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VPYulk8TC48SYA {
  flex-shrink: 0;
  margin: var(--ds-space-0, 0) 6px;
  border-radius: var(--ds-border-radius-300, 12px);
  border-color: transparent;
  background-color: hsla(0, 0%, 0%, 0.12);
  box-shadow: none;
}
.body-custom-board-background .VPYulk8TC48SYA {
  background-color: hsla(0, 0%, 0%, 0.24);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropPreview": `VPYulk8TC48SYA`
};
export default ___CSS_LOADER_EXPORT___;
